import type { ChartmetricSnapshot } from '@dashboard/contract';
import { fmtBig } from '../lib/format';

export function ChartmetricStrip({
  cm,
  loading,
}: {
  cm: ChartmetricSnapshot | null | undefined;
  loading: boolean;
}) {
  if (loading) return null;
  if (!cm) {
    return (
      <>
        <div className="cmhead" style={{ marginTop: 16 }}>
          <span className="lab">Chartmetric</span>
          <span className="chip flat">not connected</span>
        </div>
        <div className="chartmetric-off">
          The Chartmetric layer reads the Pophouse lake; it is not linked for this artist or not
          configured on this server.
        </div>
      </>
    );
  }
  const trend = cm.profile.trend ?? '';
  const trendCls = /decline/i.test(trend)
    ? 'down'
    : /growth|explosive/i.test(trend)
      ? 'up'
      : 'flat';
  const s = cm.stats;
  const rank = (r: number | null) => (r == null ? '' : `world #${r.toLocaleString('en-US')}`);
  const tiles: [string, string, string][] = [
    ['Spotify monthly listeners', fmtBig(s.spMonthlyListeners), rank(s.spMonthlyListenersRank)],
    ['Spotify followers', fmtBig(s.spFollowers), rank(s.spFollowersRank)],
    ['Playlist reach', fmtBig(s.playlistReach), `${fmtBig(s.editorialReach)} editorial`],
    [
      'SoMe following',
      fmtBig((s.instagram ?? 0) + (s.tiktok ?? 0) + (s.youtubeSubs ?? 0)),
      `IG ${fmtBig(s.instagram)} · TT ${fmtBig(s.tiktok)} · YT ${fmtBig(s.youtubeSubs)}`,
    ],
  ];
  return (
    <>
      <div className="cmhead" style={{ marginTop: 16 }}>
        <span className="lab">Chartmetric</span>
        <span className="chip flat">
          {cm.profile.stage ?? '—'} · {cm.profile.stageScore ?? '—'}
        </span>
        <span className={`chip ${trendCls}`}>{trend || '—'}</span>
        <span className="cmsrc">
          CM rank #{cm.profile.rank ?? '—'} · Pophouse lake · {cm.observedOn ?? '—'}
        </span>
      </div>
      <div className="cmstrip">
        {tiles.map(([k, v, sub]) => (
          <div className="cmt" key={k}>
            <div className="k">{k}</div>
            <div className="v">{v}</div>
            <div className="s">{sub || ' '}</div>
          </div>
        ))}
      </div>
    </>
  );
}
